/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _TransactionDetailState = {
  id: null,
  title: null,
  unit_price: 0,
  quantity: 1,
  total: 0,
  type: null // 画面制御用
}

const TYPE_FEE = 'accommodation_fee_paid'
const TYPE_TAX = 'accommodation_tax_paid'
const TYPE_OTHERS = 'others_paid'

class TransactionDetailState extends Record(_TransactionDetailState) {
  mergeModel(model) {
    return this.merge(model)
  }

  isAccommodationFee() {
    return this.type === TYPE_FEE
  }

  isAccommodationTax() {
    return this.type === TYPE_TAX
  }

  isOthers() {
    return this.type === TYPE_OTHERS
  }
}

function TransactionDetailStateOfAccommodationFee(reservation) {
  const unit_price = reservation.accommodation_fee
  const total = reservation.accommodation_fee || 0
  return new TransactionDetailState({
    title: '宿泊費',
    unit_price: unit_price,
    quantity: 1,
    total: total,
    type: TYPE_FEE
  })
}

function TransactionDetailStateOfAccommodationTax(reservation, total_tax) {
  // const unit_price = total_tax
  // const total = total_tax
  return new TransactionDetailState({
    title: '宿泊税',
    unit_price: total_tax,
    quantity: 1,
    total: total_tax,
    type: TYPE_TAX
  })
}

function TransactionDetailStateOfOthers(title, unit_price) {
  const total = unit_price || 0
  return new TransactionDetailState({
    title: title,
    unit_price: unit_price,
    quantity: 1,
    total: total,
    type: TYPE_OTHERS
  })
}

function getIndexOfTransactionDetail(name) {
  switch (name) {
    case TYPE_FEE:
      return 0
    case TYPE_TAX:
      return 1
    case TYPE_OTHERS:
      return 2
    default:
      return 2
  }
}

export { TransactionDetailState, TransactionDetailStateOfAccommodationFee, TransactionDetailStateOfAccommodationTax, TransactionDetailStateOfOthers, getIndexOfTransactionDetail }
